import { Expose, Type } from 'class-transformer';
import { BaseEntity } from './base.entity';
import { CompanyEntity } from './company.entity';

export class CompanyListEntity extends BaseEntity {
  @Expose()
  @Type(() => CompanyEntity)
  public companies: CompanyEntity[];
}
